<!--
- Placeholder label.
-->
@if (!displayAsText && !displayAsTag && !lmParagraphLayoutInfo) {
  <label
    [ngClass]="{'label lm-placeholder-label no-colon' : true, 'lm-no-label': lmColumnLayoutInfo?.isTable}"
  >&nbsp;</label>
}

@if (label) {
  <label
    soho-label
    [required]="required$ | async"
    lm-label
    [layoutField] = "field">
    {{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}
  </label>
}
@switch (displayType) {
  @case (layoutDisplayType.DISPLAY_AS_CHECKBOXES) {
    <div class="lm-checkbox-group-wrapper"
      attr.aria-labelledby="{{id}}"
      [attr.tabindex]="isInAccessibilityMode && (readOnly$ | async) ? 0 : null">
      @for (item of values$ | async; track trackByValue(indx, item); let indx = $index) {
        @if ((item && item.label != ' ') && !displayAsText) {
          <input
            type="checkbox"
            class="checkbox"
            attr.data-val="{{item.value}}"
            attr.id="{{id}}_{{indx}}_Option"
            name="{{id}}_{{indx}}_Option"
            attr.name="{{id}}_{{indx}}_Option"
            [attr.bindId]="bindId"
            [attr.disabled]="(readOnly$ | async) ? true : null"
            (click)="selectItem(item)"
            soho-checkbox
            [(ngModel)]="item.selected"
            soho-alert
            soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)">
            <label
              soho-label
              attr.for="{{id}}_{{indx}}_Option"
              class="lm-checkbox-label"
              >
              {{item?.label}}
            </label>
            @if (!isHorizontal && indx != ((values$ | async).length - 1)) {
              <br/>
            }
          }
        }
      </div>
    }
  }

  <ng-template #mouseOverTextTemplate>
    @if (layoutObject.mouseOverText) {
      <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
      ></lm-mouse-over-text>
    }
  </ng-template>
  @if (errorLiveMessage.liveMessage) {
    <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
  }
  
  <span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
